import { Card, Col, Row } from "antd";
import CustomMap from "./Components/LocationAd";
import RegionalReport from "./Components/RegionalReport/RegionalReport";
import NearByLocations from "./Components/NearByLocations";
import RightInfoDetails from "./Components/RightInfoDetails";
import LeftImageSlider from "./Components/LeftImageSlider";
import Descriptions from "./Components/Descriptions";
import Options from "./Components/Options/OptionsIndex";
import { useSearchParams, useParams, useNavigate } from "react-router-dom";
import GeneralLoadingSpinner from "apps/Common/GeneralLoadingSpinner";
import AdTitle from "./Components/AdTitle";
import { useGetAdvertDetails } from "./ServerSideStates";
import CollapseItems from "./Components/CollapesItems";
import CreditIndex from "apps/Credit/CreditIndex";
import BodyReportIndex from "apps/CustomerPanel/Ad/Components/BodyReport/BodyReportIndex";
import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { slugify } from "../../utils/slugify";

const RealStateDetailsIndex: FC<{ externalAdverId?: string }> = ({
  externalAdverId,
}) => {
  const [searchParams] = useSearchParams();
  const { slug } = useParams();
  const navigate = useNavigate();

  const { selectedAdvertIdPreview } = useSelector(
    (state: RootState) => state.realState
  );

  const advertId =
    searchParams.get("id") || externalAdverId || selectedAdvertIdPreview || "";

  const advertDetails = useGetAdvertDetails(advertId);
  const { userInfoes } = useSelector((state: RootState) => state.profile);

  // URL'yi güncelle
  useEffect(() => {
    if (advertDetails?.data?.data?.title && advertId && !searchParams.get("id")) {
      const currentSlug = slugify(advertDetails.data.data.title);
      const newPath = `/${currentSlug}/detay?id=${advertId}`;
      navigate(newPath, { replace: true });
    }
  }, [advertDetails?.data?.data?.title, advertId, slug, navigate]);

  const breadcrumbData = advertDetails?.data?.data.categoryCombinedKey;

  const parts = breadcrumbData?.split("_") || [];
  console.log("breadcrumbData",parts)
  if(parts[1] === "5278"){
    console.log("burada")
  }
  return (
    <Col span={24} className="mt-3 pb-5">
      <Row gutter={[20, 20]}>
        {advertDetails.isLoading || advertDetails.isFetching ? (
          <GeneralLoadingSpinner />
        ) : (
          <>
            <Col xs={24} lg={14} xl={16}>
              <Row
                gutter={[
                  { xs: 10, sm: 10, md: 15, lg: 20, xl: 30, xxl: 40 },
                  { xs: 5, sm: 10, md: 15, lg: 20, xl: 30, xxl: 40 },
                ]}
              >
                <Col xs={24}>
                  <Row gutter={[{ xs: 10, lg: 10 }, { xs: 5, lg: 10 }]}>
                    <Col xs={24} xl={14} className="!flex items-center">
                      <AdTitle advertDetails={advertDetails} />
                    </Col>
                    <Col
                      xs={24}
                      xl={10}
                      className="items-center justify-center sm:justify-end gap-2 !hidden xl:!flex"
                    >
                      {userInfoes?.id !==
                        advertDetails?.data?.data?.userId && <Options />}
                    </Col>
                  </Row>
                </Col>

                <Col span={24}>
                  <LeftImageSlider />
                </Col>

                <Col span={24}>
                  <Row gutter={[10, 20]}>
                    <Col span={24}>
                      <Card>
                        <Row gutter={[20, 60]}>
                          <Col xs={24} className="!block lg:!hidden !px-0 sm:px-4">
                            <RightInfoDetails />
                          </Col>
                          <Col xs={24}>
                            <Descriptions />
                          </Col>
                          <Col xs={24}>
                            {(() => {
                              const data = advertDetails?.data?.data;
                              if (data?.type === 0) {
                                return <CreditIndex />;
                              } else if (data?.type === 1 ) {
                                if(parts[1] === "2" || parts[1] === "5278"){
                                     return <BodyReportIndex readOnlyMode={true} />;
                                }
                               
                              }
                              return <></>;
                            })()}
                          </Col>
                          <Col xs={24}>
                            <CollapseItems />
                          </Col>
                          {advertDetails?.data?.data?.latitude &&
                            advertDetails?.data?.data?.longitude && (
                              <>
                                <CustomMap />
                                <NearByLocations />
                              </>
                            )}
                        </Row>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>

            <Col xs={24} lg={10} xl={8} className="!hidden lg:!block">
              <RightInfoDetails />
            </Col>
          </>
        )}
      </Row>
    </Col>
  );
};

export default RealStateDetailsIndex;
